module.exports = __webpack_public_path__ + "static/logo-251076e82975e1fdb100e6bf2a59bb33.svg";